<template>
  <div>
    <b-card-code
      title="Filter"
      style="display:none;"
      no-body
    >
      <b-card>
        <b-row
          xl="12"
          sm="12"
        >
          <b-col
            cols="12"
            md="3"
            class="mb-md-0 mb-2"
          >
            <b-button
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              class="sidebar-center"
              variant="outline-primary"
              @click="filterz()"
            >
              <feather-icon icon="SearchIcon" /> Filter
            </b-button>
          </b-col>
        </b-row>
      </b-card>
    </b-card-code>
    <b-card-code
      title=""
      no-body
    >
      <b-card>
        <div>
          <b-link :to="{ path: '/project-device/add' }">
            <b-button
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              class="sidebar-right mb-2"
              variant="outline-primary"
            >
              <feather-icon icon="PlusIcon" /> Create
            </b-button>
          </b-link>
        </div>
        <div><div class="h-50 d-inline-block" /></div>
        <div class="d-none justify-content-between flex-wrap">
          <!-- sorting  -->
          <b-form-group
            label="Sort"
            label-size="sm"
            label-align-sm="left"
            label-cols-sm="3"
            label-for="sortBySelect"
            class="ml-1"
          >
            <b-input-group size="sm">
              <b-form-select
                id="sortBySelect"
                v-model="sortBy"
                :options="sortOptions"
              >
                <template #first>
                  <option value="">
                    none
                  </option>
                </template>
              </b-form-select>
              <b-form-select
                v-model="sortDesc"
                size="sm"
                :disabled="!sortBy"
              >
                <option :value="false">
                  Asc
                </option>
                <option :value="true">
                  Desc
                </option>
              </b-form-select>
            </b-input-group>
          </b-form-group>
          <!-- filter -->
          <b-form-group
            label="Filter"
            label-cols-sm="3"
            label-align-sm="left"
            label-size="sm"
            label-for="filterInput"
            class="ml-1"
          >
            <b-input-group size="sm">
              <b-form-input
                id="filterInput"
                v-model="filter"
                type="search"
                placeholder="Type to Search"
              />
              <b-input-group-append>
                <b-button
                  :disabled="!filter"
                  @click="filter = ''"
                >
                  Clear
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </div>
        <b-table
          striped
          hover
          responsive
          class="position-relative"
          :items="items"
          :fields="fields"
          @sort-changed="sortChanged"
        >
          <template #cell(created_at)="data">
            {{ dateFormat(data.value) }}
          </template>
          <template #cell(logo)="data">
            <b-img
              width="50"
              :src="data.value"
            />
          </template>
          <template #cell(status)="data">
            <b-badge :variant="status[1][data.value]">
              {{ status[0][data.value] }}
            </b-badge>
          </template>
          <template #cell(device_type_name)="{ item }">
            {{ item.device_types.name }}
          </template>
          <template #cell(action)="row">
            <span>
              <b-dropdown
                variant="link"
                toggle-class="text-decoration-none"
                no-caret
              >
                <template v-slot:button-content>
                  <feather-icon
                    icon="MoreVerticalIcon"
                    size="16"
                    class="text-body align-middle mr-25"
                  />
                </template>
                <b-dropdown-item>
                  <b-link :to="{ path: '/project-device/detail/'+ row.item.id}">
                    <feather-icon
                      icon="Edit2Icon"
                      class="mr-50"
                    />
                    <span>Edit</span>
                  </b-link>
                </b-dropdown-item>
                <b-dropdown-item>
                  <b-link
                    v-b-modal.modal-center
                    @click="rowOnDelete(row.item.id)"
                  >
                    <feather-icon
                      icon="TrashIcon"
                      class="mr-50"
                    />
                    <span>Delete</span>
                  </b-link>
                </b-dropdown-item>
              </b-dropdown>
            </span>
          </template>
        </b-table>
        <Pagination :current-page.sync="currentPage" :per-page.sync="perPage" :total-rows="totalRows" @filter="handleFilter" />
      </b-card>
    </b-card-code>
  </div>
</template>
<script>
import Pagination from '@/views/general/components/Pagination.vue'
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import {
  BCard, BTable, BRow, BCol, BImg, BBadge, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BButton, BCardBody, BLink, BDropdown, BDropdownItem,
} from 'bootstrap-vue'
import { mapState } from 'vuex'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Ripple from 'vue-ripple-directive'
import store from '@/store/index'

export default {
  components: {
    BCardCode, BCard, BTable, BRow, BCol, BImg, BBadge, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BButton, BCardBody, BLink, BDropdown, BDropdownItem, ToastificationContent, Pagination,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      dir: false,
      currentPage: 1,
      perPage: 10,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },
      StatusOptions: [
        { title: 'Online', value: 'AC' },
        { title: 'Offline', value: 'OF' },
        { title: 'Deleted', value: 'DL' },
      ],
      status: [{
        AC: 'Available', OF: 'Offline', DL: 'Deleted', 4: 'Resigned', 5: 'Applied',
      },
      {
        AC: 'light-success', IN: 'light-danger', DL: 'light-danger', 4: 'light-warning', 5: 'light-info',
      }],
    }
  },
  computed: {
    ...mapState({
      totalRows: state => state.device.totalRows,
      fields: state => state.device.fieldsSparing,
      items: state => state.device.items,
      pageOptions: state => state.device.pageOptions,
      DeviceTypeOptions: state => state.temperature.devicetypeoptions,
    }),
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
    dateFormat() {
      // eslint-disable-next-line camelcase
      return create_at => this.$options.filters.formatDate(create_at)
    },
    direction() {
      return store.state.appConfig.isRTL
    },
  },
  mounted() {
    // Set the initial number of items
    this.$store.state.totalRows = this.items.length
  },
  created() {
    this.params = {
      page: this.currentPage,
      limit: this.perPage,
    }
    this.$store.dispatch('device/getAll', this.params)
    this.$store.dispatch('temperature/getDeviceType')
  },
  methods: {
    handleFilter(currentPage, perPage) {
      this.currentPage = currentPage
      this.perPage = perPage
      this.filterz()
    },
    sortChanged({ sortBy, sortDesc, sortDirection }) {
      this.sortBy = sortBy
      this.sortDesc = sortDesc
      this.sortDirection = sortDirection
      this.filterz()
    },
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`
      this.infoModal.content = JSON.stringify(item, null, 2)
      this.$root.$emit('bv::show::modal', this.infoModal.id, button)
    },
    resetInfoModal() {
      this.infoModal.title = ''
      this.infoModal.content = ''
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.$store.state.totalRows = filteredItems.length
      this.currentPage = 1
    },
    advanceSearch(val) {
      this.searchTerm = val
    },
    rowOnDelete(id) {
      this.$bvModal
        .msgBoxConfirm('Please confirm that you want to delete everything.', {
          title: 'Please Confirm', size: 'sm', okVariant: 'primary', okTitle: 'Yes', cancelTitle: 'No', cancelVariant: 'outline-secondary', hideHeaderClose: false, centered: true,
        })
        .then(value => {
          if (value === true) {
            this.$store.dispatch('device/remove', id)
              .then(response => {
                if (response.status === 200) {
                  this.$store.dispatch('device/getAll')
                  this.notification('Success', 'CheckIcon', 'success', 'You have successfully')
                } else {
                  this.notification('Failed', 'CloseIcon', 'danger', 'You have unsuccessful')
                }
              },
              () => {
                this.notification('Failed', 'CloseIcon', 'danger', 'You have unsuccessful')
              })
          }
        })
    },
    notification(a, b, c, d) {
      this.$toast({
        component: ToastificationContent,
        position: 'top-right',
        props: {
          title: a, icon: b, variant: c, text: d,
        },
      })
    },
    filterz() {
      if (!this.select_device_type) {
        this.select_device_type = ''
      }
      if (!this.select_status) {
        this.select_status = ''
      }
      const orderBy = this.sortBy ? JSON.stringify({ [this.sortBy]: this.sortDesc ? 'desc' : 'asc' }) : ''
      this.params = {
        select_device_type: this.select_device_type,
        select_device_status: this.select_status,
        page: this.currentPage,
        limit: this.perPage,
      }
      if (orderBy) {
        this.params.orderBy = orderBy
      }
      this.$store.dispatch('device/getAll', this.params)
    },
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
